import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import menubar_en from './locales/en/menubar.json';
import menubar_ko from './locales/ko/menubar.json';
import adminpage_ko from './locales/ko/adminpage.json';
import adminpage_en from './locales/en/adminpage.json';
import processing_ko from './locales/ko/processing.json';
import processing_en from './locales/en/processing.json';
import createarea_ko from './locales/ko/createarea.json';
import createarea_en from './locales/en/createarea.json';
import upload_ko from './locales/ko/upload.json';
import upload_en from './locales/en/upload.json';


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        menubar: menubar_en,   // ✅ 네임스페이스 이름을 key로 사용
        adminpage: adminpage_en,
        processing: processing_en,
        createarea: createarea_en,
        upload: upload_en

      },
      ko: {
        menubar: menubar_ko,   // ✅ 동일하게 맞춤
        adminpage: adminpage_ko,
        processing: processing_ko,
        createarea: createarea_ko,
        upload: upload_ko
      }
    },
    fallbackLng: 'ko',
    ns: ['menubar','adminpage','processing','createarea','upload'],       // ✅ 실제 네임스페이스와 일치
    defaultNS: 'menubar',  // ✅ 기본 네임스페이스도 맞춰줌
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
